module.exports = __webpack_public_path__ + "static/media/mendi.20858da6.jpg";